/**
 * scripts.js
 *
 * This is where you should write your custom javascript code
 */


$(function () {
    $('a[href*=\\#]').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top
        }, 500, 'linear');
    });
});

if ($('.scroll-reveal').length > 0) {
    sr.reveal('.scroll-reveal', {
        // 'bottom', 'left', 'top', 'right'
        origin: 'bottom',

        // Can be any valid CSS distance, e.g. '5rem', '10%', '20vw', etc.
        distance: '20px',

        // Time in milliseconds.
        duration: 500,
        delay: 0,

        // Starting angles in degrees, will transition from these values to 0 in all axes.
        rotate: { x: 0, y: 0, z: 0 },

        // Starting opacity value, before transitioning to the computed opacity.
        opacity: 0,

        // Starting scale value, will transition from this value to 1
        scale: 0.9,

        // Accepts any valid CSS easing, e.g. 'ease', 'ease-in-out', 'linear', etc.
        easing: 'cubic-bezier(0.6, 0.2, 0.1, 1)',

        // `<html>` is the default reveal container. You can pass either:
        // DOM Node, e.g. document.querySelector('.fooContainer')
        // Selector, e.g. '.fooContainer'
        container: window.document.documentElement,

        // true/false to control reveal animations on mobile.
        mobile: false,

        // true:  reveals occur every time elements become visible
        // false: reveals occur once as elements become visible
        reset: false,

        // 'always' — delay for all reveal animations
        // 'once'   — delay only the first time reveals occur
        // 'onload' - delay only for animations triggered by first load
        useDelay: 'always',

        // Change when an element is considered in the viewport. The default value
        // of 0.20 means 20% of an element must be visible for its reveal to occur.
        viewFactor: 0.2,
    });
}


$(function () {
    $('#gallery').photoSwipe('img', {
        shareEl: false,
        captionEl: false,
        fullscreenEl: false
    });
});


if (document.querySelector('.masonry-grid')) {
    var grid = document.querySelector('.masonry-grid');
    var msnry = new Masonry(grid, {
        itemSelector: '.grid-item',
        columnWidth: '.grid-sizer',
        percentPosition: true
    });
    imagesLoaded(grid).on('progress', function () {
        msnry.layout();
    });
}


// Jumbotron Slider
$('.jumbotron-slider').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1000,
    arrows: false,
    swipe: false,
    touchMove: false,
    draggable: false,
    dots: false,
    fade: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    pauseOnDotsHover: false
});

// Navbar Show/Hide
var slider = document.querySelector('.jumbotron-slider');
var hero = document.querySelector('.jumbotron');

if (slider) {
    var offset = slider.offsetHeight;
} else if (hero) {
    var offset = hero.offsetHeight;
} else {
    offset = 0;
}

var navbar = document.querySelector('.navbar');
var navbarCollapse = document.querySelector('#navbarDefault');
var headroom = new Headroom(navbar, {
    "offset": offset,
    "tolerance": {
        "down": 10,
        "up": 15
    },
    "classes": {
        "initial": "animated",
        "pinned": "slideInDown",
        "unpinned": "slideOutUp",
        "top": "navbar-top",
        "notTop": "navbar-not-top",
        "bottom": "navbar-bottom",
        "notBottom": "navbar-not-bottom"
    },
    onUnpin: function() {
        if (navbarCollapse.classList.contains('show')) {
            setTimeout(function(){
                $('#navbarDefault').collapse('hide');
            }, 525);
        }
    },
});
headroom.init();

// Contact Form
var form = $('#form');
if (form.length > 0) {
    // Get Sender IP Info and Store City & Region
    var city;
    var region;
    function lookup() {
        $.getJSON('https://ipinfo.io/', function(data) {
            city = data.city;
            region = data.region;
        })
    }
    lookup();
    // Contact Form Submit
    form.on('submit', function(e) {
        e.preventDefault();
        var formData = $(form).serialize();
        var first = $('#first').val();
        var last = $('#last').val();
        var name = first + ' ' + last;
        var response = grecaptcha.getResponse();
        $.ajax({
            type: 'POST',
            url: form.attr('action'),
            data: formData + '&city=' + city + '&region=' + region
        })
        var icon = $('.mail-notification i.fal');
        var message = $('.mail-notification .mail-message');
        var notification = $('.mail-notification');
        if (response.length == 0) {
            if (notification.hasClass('d-none')) {
                // icon.addClass('fa-exclamation-triangle');
                message.text('Please verify your humanity to send your request.');
                notification.toggleClass('alert-warning d-none').removeClass('fadeOutUp').addClass('slideInDown');
                notification.delay(6000).queue(function() {
                    $(this).removeClass('slideInDown').addClass('fadeOutUp').dequeue();
                });
                notification.delay(1000).queue(function() {
                    $(this).toggleClass('alert-warning d-none').removeClass('fadeOutUp').dequeue();
                    // icon.removeClass('fa-exclamation-triangle');
                });
            }
            $('.g-recaptcha').toggleClass('shake');
            setTimeout(function() {
                $('.g-recaptcha').toggleClass('shake');
            }, 1000);
        } else {
            if (notification.hasClass('d-none')) {
                // icon.addClass('fa-check-circle');
                message.text('Thank you for getting in touch with us ' + name + '. We will get back to you with a response shortly!');
                notification.toggleClass('alert-success d-none').removeClass('fadeOutUp').addClass('slideInDown');
                notification.delay(6000).queue(function() {
                    $(this).removeClass('slideInDown').addClass('fadeOutUp').dequeue();
                });
                notification.delay(1000).queue(function() {
                    $(this).toggleClass('alert-success d-none').removeClass('fadeOutUp').dequeue();
                    // icon.removeClass('fa-check-circle');
                });
            }
            form.find('input[type=text], input[type=email], input[type=tel], textarea').val('');
            grecaptcha.reset()
        }
    });
}

// Material Contact Form Animation
$('#form').find('.form-control').each(function() {
  var targetItem = $(this).parent();
  if ($(this).val()) {
    $(targetItem).find('label').css({
      'top': '10px',
      'fontSize': '14px'
    });
  }
})
$('#form').find('.form-control').focus(function() {
  $(this).parent('.form-group').addClass('focus');
  $(this).parent().find('label').animate({
    'top': '10px',
    'fontSize': '14px'
  }, 200);
})
$('#form').find('.form-control').blur(function() {
  if ($(this).val().length == 0) {
    $(this).parent('.form-group').removeClass('focus');
    $(this).parent().find('label').animate({
      'top': '30px',
      'fontSize': '14px'
    }, 200);
  }
})

// Phone Number Mask
if (document.getElementById('phone')) {
    document.getElementById('phone').addEventListener('input', function (e) {
      var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    });
}


// WEBPACK FOOTER //
// ./src/js/scripts.js